<template>
	<div>
		<div>
			<tabvendas
				:data="myData"
				:is-loading="isLoading"
				@editAction="editTable($event)"
				@searchtext="searchTerm = $event"
			/>
			<modal v-if="modalVisible" title="Editar" @closemodal="closeModal()">
				<template v-slot:modalcontent>
					<div class="container-slot-modal">
						<b-field label="Name">
							<b-input v-model="modalSelectedData.descricao" />
						</b-field>
						<b-field label="Status">
							<b-switch v-model="modalSelectedData.status" :true-value="1" :false-value="0">
								{{ modalSelectedData.status === 0 ? 'Inativo' : 'Ativo' }}
							</b-switch>
						</b-field>

						<b-field label="Id Integração">
							<b-input v-model="modalSelectedData.integracao_id" />
						</b-field>
						<div class="actions-button">
							<b-button type="is-success" outlined @click="saveAction()"> Salvar </b-button>
							<b-button type="is-danger" outlined> Cancelar </b-button>
						</div>
					</div>
				</template>
			</modal>

			<modal v-if="modalAddCondPagamento" title="Adicionar" @closemodal="closeModalAdd()">
				<template v-slot:modalcontent>
					<div class="container-slot-modal">
						<b-field label="Name">
							<b-input v-model="addTabVendas.descricao" />
						</b-field>
						<b-field label="Status">
							<b-switch v-model="addTabVendas.status" :true-value="1" :false-value="0">
								{{ addTabVendas.status === 0 ? 'Inativo' : 'Ativo' }}
							</b-switch>
						</b-field>
						<b-field label="Id Integração">
							<b-input v-model="addTabVendas.integracao_id" />
						</b-field>
						<div class="actions-button">
							<b-button type="is-success" outlined @click="addAction()"> Adicionar </b-button>
							<b-button type="is-danger" outlined> Cancelar </b-button>
						</div>
					</div>
				</template>
			</modal>
		</div>
	</div>
</template>

<script>
import tabvendas from '../../layout/components/table/tabvendas';
import modal from '../../layout/components/modal/modal';
import * as ecAxios from '../../util/ecAxios';

export default {
	components: {
		tabvendas,
		modal,
	},
	data() {
		return {
			isSwitchedCustom: 'Inativo',
			addTabVendas: {
				descricao: '',
				associado_id: 1,
				integracao_id: '',
				status: 1,
			},
			modalVisible: false,
			data: [],
			searchTerm: '',
			modalSelectedData: {},
			isLoading: false,
		};
	},
	computed: {
		modalAddCondPagamento() {
			return this.$store.getters.getModalCondPagamento;
		},
		myData() {
			const searchData = this.searchTerm;
			if (searchData) {
				return this.data.filter((item) => this.filterSearch(item.descricao));
			}
			return this.data;
		},
	},
	created() {
		this.getAllData();
	},
	methods: {
		async addAction() {
			if (this.addTabVendas.descricao !== '') {
				await ecAxios
					.connection()
					.post(
						`${process.env.VUE_APP_API_ADM_EC}
        ${api.env.EC_TABVND_SALVAR}`,
						this.addTabVendas
					)
					.then((response) => {
						if (response.data.error === 0) {
							this.$store.dispatch('setModalCondPagamento', false);
							this.getAllData();
							this.$buefy.notification.open({
								message: response.data.message,
								type: 'is-success',
							});
						}
					})
					.catch((e) => {
						this.$buefy.notification.open({
							message: e,
							type: 'is-danger',
						});
					});
			}
		},
		closeModalAdd() {
			this.$store.dispatch('setModalCondPagamento', false);
		},
		filterSearch(field) {
			if (typeof field === 'number') {
				// eslint-disable-next-line no-param-reassign
				field = field.toString();
			}
			if (field === null) {
				// eslint-disable-next-line no-param-reassign
				field = '';
			}
			return field.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
		},
		async getAllData() {
			this.isLoading = true;
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_TABVND}`)
				.then((response) => {
					if (response.data.error === 0) {
						this.data = response.data.tabvnds;
					}
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-danger',
					});
				});
			this.isLoading = false;
		},
		editTable(selected) {
			this.modalSelectedData = selected;
			this.modalVisible = !this.modalVisible;
		},
		async saveAction() {
			await ecAxios
				.connection()
				.put(
					`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_TABVND_SALVAR}${this.modalSelectedData.id}`,
					{
						associado_id: this.modalSelectedData.associado_id,
						descricao: this.modalSelectedData.descricao,
						integracao_id: this.modalSelectedData.integracao_id,
						status: this.modalSelectedData.status,
					}
				)
				.then((response) => {
					if (response.data.error === 0) {
						this.modalVisible = !this.modalVisible;
					}
				})
				.catch();
		},
		closeModal() {
			this.modalVisible = !this.modalVisible;
		},
	},
};
</script>

<style scoped>
.actions-button {
	display: flex;
	width: 50%;
	height: 100px;
	align-items: center;
	justify-content: space-between;
}

.container-slot-modal {
	width: 100%;
	flex-direction: column;
	display: flex;
}
</style>

